import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";

interface iUserChoiceHistoryWorkflowResponse {
  total_count: number;
  workflow_summaries: {
    PPI_Inhibitor : {
        total_count: number;
        summary: [
            {
                period: string;
                count: number;
            }
        ]
    },
    Kinase_Inhibitor:{
        total_count: number;
        summary: [
            {
                period: string;
                count: number;
            }
        ]
    },
    drug_response:{
        total_count : number;
        summary:[
          {
                period: string;
                count : number;
          }
        ]
    }
 };
}

export interface iUserChoiceHistoryWorkflowState {
  response: iUserChoiceHistoryWorkflowResponse | null;
  isLoading: boolean;
  message: string | null;
}

const initialResponse: iUserChoiceHistoryWorkflowResponse = {
  total_count: 0,
  workflow_summaries: {
    PPI_Inhibitor: {
        total_count: 0,
        summary: [
            {
                period: "",
                count: 0,
            }
        ]
    },
    Kinase_Inhibitor: {
        total_count: 0,
        summary: [
            {
                period: "",
                count: 0,
            }
        ]
    },
    drug_response : {
        total_count : 0,
        summary: [
          {
                period:"",
                count : 0
          }
        ]
    }
  },
};

const initialState: iUserChoiceHistoryWorkflowState = {
  response: initialResponse,
  isLoading: false,
  message: "",
};

export const userChoiceHistoryWorkflowAPI = createAsyncThunk(
  "userChoiceHistoryWorkflowAPI",
  async (params: {group_name : string, start_date : string, end_date:string , round:number, workflow_name:string}, { rejectWithValue }) => {
    try {
      const djangoEndpoint = getDjangoEndpoint();
      const pathParam = '/dashboard/excute-history-workflow/?start_date=' + params.start_date + '&end_date=' + params.end_date;
      const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

const userChoiceHistoryWorkflowSlice = createSlice({
  name: "userChoiceHistoryWorkflow",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userChoiceHistoryWorkflowAPI.pending, (state) => {
        state.isLoading = true;
        state.message = "";
      })

        .addCase(userChoiceHistoryWorkflowAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.response = action.payload;
        })
        .addCase(userChoiceHistoryWorkflowAPI.rejected, (state, action) => {
            state.isLoading = false;
            state.message = action.payload as string;
        }
      );
  }
});

export default userChoiceHistoryWorkflowSlice.reducer;